module.exports = __webpack_public_path__ + "media/images/help/scoring-run-result-1-ce3527ab72aefb33059b66c16b4852fb.png";